import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '../../../Context';
import shortenNumber from '../../../utils/shortenNumber';
import s from './StatNumber.scss';
export var StatNumber = function (_a) {
    var value = _a.value, isValueClickable = _a.isValueClickable;
    var isMobile = useContext(MobileContext);
    if (typeof value === 'undefined') {
        return null;
    }
    return (React.createElement("span", { className: classnames(s['stat-value'], isValueClickable && !isMobile && s['clickable']) }, typeof value === 'undefined' ? null : shortenNumber(value)));
};
StatNumber.displayName = 'StatNumber';
export default StatNumber;
//# sourceMappingURL=StatNumber.js.map